import axios from "axios";
import utils from "./utils";

const originalResilienzaUrl = "https://api.mycompass.app/fissa-appuntamento";
let resilienzaUrl = "https://api.mycompass.app/fissa-appuntamento";
const localUrl = ".";
if (
  window.location.hostname == "compass-col.int.compassonline.it" ||
  window.location.hostname == "compassquinto-col.int.compassonline.it" ||
  window.location.hostname == "localhost"
) {
  resilienzaUrl = localUrl;
}

let hash = '';

const makeid = function (length) {
  if (!length) {
    length = 20;
  }
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const apiInvoker = {
  Ping(payload, callback, error) {
    hash = makeid();
    this.InvokeRes("/api/Filiali/ping", payload, callback, error);
  },
  TrovaFiliali(payload, callback, error) {
    this.InvokeRes("/api/Filiali/TrovaFiliali", payload, callback, error);
  },
  TrovaFiliale(idFiliale, callback, error) {
    const payload = {
      IdFiliale: idFiliale
    };
    this.InvokeRes("/api/Filiali/TrovaFiliale", payload, callback, error);
  },
  GiorniDisponibili(payload, callback, error) {
    this.InvokeRes("/api/Filiali/GiorniDisponibili", payload, callback, error);
  },
  DisponibilitaFiliale(payload, callback, error) {
    this.InvokeRes("/api/Filiali/Disponibilita", payload, callback, error);
  },
  CheckByCF(cf, flusso, callback, error) {
    let self = this;
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6LeR4s8UAAAAAD6c_HG0bGl45h6TOaUwL_Y5MjB3', { action: flusso }).then(function (token) {
        const payload = {
          'cf': cf,
          'flusso': flusso,
          'token': token
        };
        self.InvokeRes('/api/Appuntamento/CheckByCFAsync', payload, callback, error);
      });
    });
  },
  encodeToken(payload, callback, error) {
    this.InvokeRes("https://api.mycompass.app/fissa-appuntamento/api/Token/Encode", payload, callback, error);
  },
  CheckCFC5(cf, callback, error) {
    let self = this;
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6LeR4s8UAAAAAD6c_HG0bGl45h6TOaUwL_Y5MjB3', { action: 'check_c5' }).then(function (token) {
        const payload = {
          'cf': cf,
          'token': token
        };
        self.InvokeRes('/api/Appuntamento/CheckCFC5', payload, callback, error);
      });
    });
  },
  CreaAppuntamentoAsync(payload, callback, error) {
    this.InvokeRes(
      "/api/Appuntamento/CreaAppuntamentoAsync",
      payload,
      callback,
      error
    );
  },
  SetPrivacyFromToken(payload, callback, error) {
    this.InvokeRes(
      "/api/Appuntamento/SetPrivacyFromToken",
      payload,
      callback,
      error
    );
  },
  CheckToken(token, callback, error) {
    const payload = {
      token: token
    };
    const gState = utils.getState();
    const pathname = '/api/Token/Decode';
    let hostname = '';

    if (
      (document.location.hostname.includes('compass-col.int.compassonline.it') && document.referrer.includes('chatbot-fissa-appuntamento'))
      || gState.access_route == '/clink'
   ) {
      hostname = "https://api.mycompass.app/fissa-appuntamento";
    }

    const endpoint = hostname + pathname;

    this.InvokeRes(endpoint, payload, callback, error);
  },
  InvokeRes(path, payload, callback, error) {
    let api_url = path;

    if (!api_url.includes('https://api.mycompass.app/')) {
      api_url = resilienzaUrl + path;
    }
    //this.InvokeLocal(path, payload, callback, error);
    axios
      .post(api_url, payload, {
        headers: {
          "Content-Type": "application/json",
          "Res": hash
        }
      })
      .then(callback)
      .catch(res => {
        //resilienza non risponde, chiamo direttamente
        this.InvokeLocal(path, payload, callback, error);
      });
  },
  InvokeLocal(path, payload, callback, error) {
    let defPath = localUrl + path;
    if (path.indexOf('http')!=-1) { //E' una chiamata esterna
      defPath = path;
    }
    axios
      .post(defPath, payload, {
        headers: { "Content-Type": "application/json" }
      })
      .then(callback)
      .catch(error);
  }
};
export default apiInvoker;



// WEBPACK FOOTER //
// ./src/modules/apiInvoker.js